import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id CFD48DE8-0DA8-455C-9C4C-337EDC54D7C0
 * name surround-sound-5-1
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/surround-sound-5-1.svg
 * tags
 * - Audio 
 */
export const SurroundSound51Icon = createSvgIcon(<><path d="M14 17H12V15H14V17M20 7V17H18V9H16V7H20M10 7V9H6V11H8C9.1 11 10 11.9 10 13V15C10 16.1 9.1 17 8 17H4V15H8V13H4V7H10Z" /></>, 'SurroundSound51Icon');
export default SurroundSound51Icon